/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Earningsnextpayout2Inputs */

const en_earningsnextpayout2 = /** @type {(inputs: Earningsnextpayout2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next payout on ${i?.date}`)
};

const de_earningsnextpayout2 = /** @type {(inputs: Earningsnextpayout2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nächste Auszahlung am ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Next payout on {date}" |
*
* @param {Earningsnextpayout2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsnextpayout2 = /** @type {((inputs: Earningsnextpayout2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsnextpayout2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsnextpayout2(inputs)
	return de_earningsnextpayout2(inputs)
});
export { earningsnextpayout2 as "earningsNextPayout" }